import { atom } from 'recoil';

export const assessmentReportChartImageState = atom({
    key: 'assessmentReportChartImageState',
    default: new Map<string, string>(),
});
